import React from 'react';

const DownloadsList = () => (
  <ul className="m-0 p-0">
    <li className="text-sm list-none text-center py-2 md:text-left">
      <a
        href="https://www.sportdog.com/media/downloads/415-1139-11.pdf"
        target="_blank"
        rel="noopener noreferrer"
        className="text-foreground-muted uppercase no-underline hover:underline"
      >
        Get the Catalog
      </a>
    </li>
    <li className="text-sm list-none text-center py-2 md:text-left">
      <a
        href="https://www.sportdog.com/media/downloads/SportDOG_Basic_Training_Manual_400-1131-1_web.pdf"
        target="_blank"
        rel="noopener noreferrer"
        className="text-foreground-muted uppercase no-underline hover:underline"
      >
        Basic Training Manual
      </a>
    </li>
  </ul>
);

export default DownloadsList;
